function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(20360 -2012)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 36,
  height: 36,
  transform: "translate(-20360 2012)",
  fill: "none"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-20354.646 2019.886)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-3279.072,4137.545h-8.175a4.45,4.45,0,0,1-4.346-3.43,4.422,4.422,0,0,1,2.791-5.1,4.32,4.32,0,0,1,1.415-.241q8.376-.025,16.752-.008a4.349,4.349,0,0,1,4.216,3.973,4.409,4.409,0,0,1-3.756,4.779,4.474,4.474,0,0,1-.682.027Zm.04-1.844c2.777,0,5.554.014,8.332-.007a2.369,2.369,0,0,0,2.145-1.335,2.406,2.406,0,0,0-.1-2.594,2.651,2.651,0,0,0-2.407-1.192q-7.969.007-15.939,0a6.124,6.124,0,0,0-.681.047,2.641,2.641,0,0,0-2.17,2.729,2.591,2.591,0,0,0,2.654,2.348Q-3283.118,4135.7-3279.032,4135.7Z",
  transform: "translate(3291.692 -4117.317)",
  fill: "currentColor",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-3239.112,3986.711h2.737a2.486,2.486,0,0,1,2.58,2.256c.01.292.168.323.428.321,1.486-.01,2.975-.042,4.458.025a2.386,2.386,0,0,1,2.106,2.279c.016.952.014,1.9,0,2.857a2.468,2.468,0,0,1-2.3,2.329c-1.394.027-2.79.03-4.184-.01a3.041,3.041,0,0,1-1.1-.341.648.648,0,0,0-.584-.022,4.3,4.3,0,0,1-1.415.364c-1.85.041-3.7.018-5.552.017a2.423,2.423,0,0,1-2.509-2.355q-.068-2.674,0-5.351a2.457,2.457,0,0,1,2.516-2.366C-3240.99,3986.7-3240.051,3986.711-3239.112,3986.711Zm-.011,8.232q1.348,0,2.7,0c.615,0,.823-.2.825-.819q.008-2.354,0-4.709c0-.653-.195-.843-.839-.844q-2.616,0-5.232,0c-.811,0-.975.167-.977,1q0,1.69,0,3.38c0,.429-.017.86.013,1.288.039.53.246.7.776.7C-3240.948,3994.945-3240.035,3994.943-3239.123,3994.943Zm7.938,0c.617,0,1.235,0,1.852,0,.444,0,.692-.216.7-.649q.027-1.268,0-2.537a.584.584,0,0,0-.626-.643q-1.933-.021-3.866,0c-.422.006-.6.219-.609.644q-.016,1.247,0,2.5c.006.483.214.68.7.685C-3232.421,3994.948-3231.8,3994.943-3231.186,3994.943Z",
  transform: "translate(3248.278 -3986.707)",
  fill: "currentColor",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-3052.828,4169.376a1.182,1.182,0,0,1-1.24,1.194,1.187,1.187,0,0,1-1.2-1.281,1.141,1.141,0,0,1,1.263-1.19A1.146,1.146,0,0,1-3052.828,4169.376Z",
  transform: "translate(3074.307 -4153.489)",
  fill: "currentColor",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-3243.025,4168.105a1.131,1.131,0,0,1,1.208,1.245,1.165,1.165,0,0,1-1.209,1.226,1.167,1.167,0,0,1-1.228-1.247A1.13,1.13,0,0,1-3243.025,4168.105Z",
  transform: "translate(3248.074 -4153.495)",
  fill: "currentColor",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-3147.488,4169.344a1.156,1.156,0,0,1-1.194,1.229,1.2,1.2,0,0,1-1.24-1.251,1.155,1.155,0,0,1,1.24-1.221A1.11,1.11,0,0,1-3147.488,4169.344Z",
  transform: "translate(3161.341 -4153.49)",
  fill: "currentColor",
  fillRule: "evenodd"
})));

function SvgIconStation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStation);
export default __webpack_public_path__ + "static/media/icon-station.44ded464.svg";
export { ForwardRef as ReactComponent };